import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DownloadFileService {
    constructor(http) {
        this.http = http;
    }
    export(path) {
        const headers = new HttpHeaders().set('skipLoader', 'true');
        return Observable.create(observer => {
            this.http.get(path, {
                headers: headers,
                responseType: 'blob',
            }).subscribe(data => {
                observer.next(data);
            }, error => {
                observer.error(error);
            }, () => observer.complete());
        });
    }
}
DownloadFileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DownloadFileService_Factory() { return new DownloadFileService(i0.ɵɵinject(i1.HttpClient)); }, token: DownloadFileService, providedIn: "root" });
